<template>
  <div
    class="user-card text-left"
  >
    <div class="card-wrapper row flex-wrap">
      <div class="col-12 col-md-2 column">
        <h1
          class="title"
          style="font-size: 0.9rem !important;"
        >
          #{{ user.id }}
        </h1>
        <h1
          class="subtitle"
          @click="$router.push({ path: `/admin/user/${user.id}` })"
        >
          {{ user.first_name }} {{ user.last_name }}
        </h1>
      </div>

      <div class="col-12 col-md-3 column">
        <div>
          <span class="sm-text">
            {{ user.email }}
          </span>
        </div>
        <h1 class="municipality">
          {{ userRoleText }}
        </h1>
      </div>

      <div
        class="col-12 col-md-3 column"
        style="padding: 0 45px;"
      >
        <div class="sm-text">
          {{ $t('generic.active', 'Active') }}:
          <span :class="user.active ? 'text-success' : 'text-danger'">
            {{ user.active ? $t('generic.yes', 'Yes') : $t('generic.no', 'No') }}
          </span>
        </div>
        <div class="sm-text">
          {{ $t('generic.verified', 'Verified') }}:
          <span :class="user.is_verified ? 'text-success' : 'text-danger'">
            {{ user.is_verified ? $t('generic.yes', 'Yes') : $t('generic.no', 'No') }}
          </span>
        </div>
        <div class="sm-text">
          <font-awesome-icon
            icon="clock"
          />
          {{ user.created_at }}
        </div>
      </div>
      <div
        class="col-12 col-md-3 column"
        style="padding: 0 45px;"
      >
        <b-dropdown
          id="dropdown-1"
          :text="$t('generic.actions', 'Actions')"
          size="sm"
          class="m-md-2"
        >
          <!-- For all -->
          <b-dropdown-item
            class="p-0"
            @click.stop="$router.push({ path: `/admin/user/${user.id}` })"
          >
            {{ $t('cards.one-user.actions.view', 'View profile') }}
          </b-dropdown-item>
          <!--  -->

          <!-- Admin -->
          <b-dropdown-item
            v-if="$hasRole(['admin'])"
            class="p-0"
            @click.stop="$router.push({ name: 'user-profile', query: { id: user.id } })"
          >
            Edit profile
          </b-dropdown-item>
          <!-- -->

          <!-- For Candidates  -->
          <b-dropdown-item
            v-if="!isDelegateRoute && (user.active && user.is_verified && userRole === 'candidate')"
            class="p-0"
            @click.stop="$router.push({ path: '/jobs/hr/delegate/offer/' + user.id + '?status=active' })"
          >
            {{ $t('cards.one-user.actions.delegate-offer', 'Delegate offer') }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="isDelegateRoute && (user.active && user.is_verified && userRole === 'candidate')"
            class="p-0"
            @click="$emit('delegateModalToggle', user.id)"
          >
            {{ $t('cards.one-user.actions.delegate-user', 'Delegate this user') }}
          </b-dropdown-item>
          <!--  -->

          <!-- For HR -->
          <b-dropdown-item
            v-if="$can('users_manage') && userRole === 'hr'"
            class="p-0"
            @click.stop="$router.push({ path: `/jobs/admin/hr/manage/${user.id}` })"
          >
            {{ $t('cards.one-user.actions.manage-companies', 'Manage companies') }}
          </b-dropdown-item>
          <!--  -->
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      user: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
      };
    },

    computed: {
      isDelegateRoute() {
        let routeChunks = this.$route.path.split("/");
        let route = routeChunks[1]
          + '/' + routeChunks[2]
          + '/' + routeChunks[3];

        return route === 'jobs/hr/delegate';
      },
      userRole() {
        return this.user.rolesVar && this.user.rolesVar[0]
          ? this.user.rolesVar[0]
          : 'candidate';
      },
      userRoleText() {
        let text;
        if(this.userRole === 'candidate') {
          text = this.$t('cards.one-user.role.candidate', 'Candidate');
        } else if(this.userRole === 'employer') {
          text = this.$t('cards.one-user.role.company', 'Company');
        } else if(this.userRole === 'hr') {
          text = this.$t('cards.one-user.role.headhunter', 'Headhunter');
        } else if(this.userRole === 'admin') {
          text = this.$t('cards.one-user.role.admin', 'Admin');
        }
        return text;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .user-card {
    background: white;
    padding: 15px 25px;
    margin-bottom: 0.5rem;
    transition: 0.2s ease;
    cursor: pointer;

    &:hover {
      box-shadow: 3px 3px 20px 0 rgba(210,210,210,1);
    }
  }

  h1.title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
    cursor: pointer;
  }

  h1.subtitle {
    color: #009090;
    font-size: 0.7rem !important;
    text-transform: uppercase;
  }

  h1.municipality {
    color: #777;
    font-size: 0.8rem !important;
  }

  .sm-text {
    font-size: 0.9rem;
    color: #666;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .expired-offer {
    background: #f1ebeb;
    border: 1px solid white;
  }

  .column {
    margin: auto;
  }

  .card-wrapper {
    flex-direction: row;

    @media screen and (max-width: 767px) {
      & {
        flex-direction: column;
      }

      .column {
        text-align: left;
      }
    }
  }

  .icon {
    cursor: pointer;
  }

  .card {
    background: red;
  }
</style>
